"use strict";
define('components/login',['components/ajax', 'components/two_fa'], function(ajax, two_fa) {
    /*
     * Login component handles logins and password resets.
     */

    var login = {

        init: function () {
            var loginBox = $('#login');
            if (loginBox.length == 0) {
                return;
            }
            this.initLoginBox(loginBox);
            this.initActivateButton(loginBox);
            two_fa.init();
        },

        initLoginBox: function(loginBox) {
            var self = this;

            var signinForm = $('#signin_tab form');
            var resetForm = $('#password_reset_tab form');

            // Submit the form via ajax instead of full-page post
            loginBox.on('submit', function(e) {
                if (typeof(FormData) != 'function') {
                    return true;
                }
                e.preventDefault();
                var formData = new FormData(e.target);  // No need to use form.serialize
                $(e.target).find('button')
                           .addClass('disabled')
                           .attr('disabled', true)
                           .find('img')
                           .removeClass('hidden')
                ajax($(e.target).attr('action'), {
                    formData: formData,
                    onSuccess: function(result) {
                        // Nothing to do if this login was successful (ie. redirects to dashboard)
                        if (result.location) {
                            return;
                        }
                        $(e.target).find('button')
                                   .removeClass('disabled')
                                   .attr('disabled', false)
                                   .find('img')
                                   .addClass('hidden');

                        if (result.form_message) {
                            loginBox.find('.form-message').html(result.form_message)
                                                          .removeClass('hidden');
                        } else {
                            loginBox.find('.form-message').addClass('hidden');
                        }
                        loginBox.find('form').removeClass('has-error');
                        loginBox.find('form').find('.form-error').html('')
                                                                 .addClass('hidden');
                        signinForm.find('input:not(:hidden)').val('');
                        $('#signin_tab').addClass('active');
                        $('#password_reset_tab').removeClass('active');
                        resetForm.find('input:not(:hidden)').val('');
                        // render pillar for unified portal 2FA flow
                        if (typeof window.__jsqRenderPillars__ === 'function') {
                            window.__jsqRenderPillars__();
                        }
                    },
                    onFailure: function(result) {
                        $(e.target).find('button')
                                   .removeClass('disabled')
                                   .attr('disabled', false)
                                   .find('img')
                                   .addClass('hidden');

                        if (result.form_message) {
                            loginBox.find('.alert').html(result.form_message)
                                                   .removeClass('hidden');
                        } else {
                            loginBox.find('.alert').addClass('hidden');
                        }
                        signinForm.addClass('has-error');
                        signinForm.find('.form-error').html(result.form_error)
                                                      .removeClass('hidden');
                    },
                    onError: function(result) {
                        $(e.target).find('button')
                                   .removeClass('disabled')
                                   .attr('disabled', false)
                                   .find('img')
                                   .addClass('hidden');

                        signinForm.addClass('has-error');
                        signinForm.find('.form-error').html('Access is denied. This server can not verify your login session. This may be due to session timeout or because browser is not supplying the credentials required, as can happen when the browser has cookies turned off. Please refresh the page and try again.')
                                                      .removeClass('hidden');
                    }
                });
            });
        },

        initActivateButton: function(loginBox) {
            $('button#activate').click(function(e) {
                var activateForm = $(this).closest('form');
                var formData = new FormData(activateForm[0]);
                ajax(activateForm.attr('action'), {
                    formData: formData,
                    onSuccess: function(result) {
                        if (result.activated_email_address) {
                            $('#login').addClass('hidden');
                            $('#confirmation').removeClass('hidden');
                            $('#activated_email_address').html(result.activated_email_address);
                        }
                    },
                    onFailure: function(result) {
                        activateForm.addClass('has-error');
                        activateForm.find('.form-error').html(result.error_message)
                                                        .removeClass('hidden');
                    },
                });
            });
        },
    };

    return login;
});

